const FilterDetails = () => {
  return (
    <>
      <div
        className="tab-pane fade active show"
        id="v-pills-category"
        role="tabpanel"
        aria-labelledby="v-pills-category-tab"
      >
        <div>
          <div className="mb-3">
            <h5 className="text-normal text-black">Categories</h5>
          </div>
          <div className="accordion-1 mb-2 p-0">
            <div className="accordion active" id="accordionWomen">
              <div className="accordion-item mb-0">
                <h6 className="accordion-header" id="headingWomen">
                  <button
                    className="accordion-button p-0 align-items-baseline font-weight-bold text-xl"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseWomen"
                    aria-expanded="false"
                    aria-controls="collapseWomen"
                  >
                    <h6 className="text-dark text-normal">Women</h6>
                    <small className="collapse-close  text-sm pt-1 position-absolute end-0 me-3">
                      <img src="../../assets/img/svg/down.svg" alt="" />
                    </small>
                    <small className="collapse-open text-sm pt-1 position-absolute end-0 me-3">
                      <img src="../../assets/img/svg/up.svg" alt="" />
                    </small>
                  </button>
                </h6>
                <div
                  id="collapseWomen"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingWomen"
                  data-bs-parent="#accordionWomen"
                >
                  <div className="accordion-body text-start text-sm">
                    <div className="input-group input-group-outline mb-3">
                      <input
                        type="text"
                        className="form-control w-100"
                        placeholder="Search for categories"
                      />
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Blazzers & Waistcoats{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Blouses{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Chudidhar & Leggings{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Dress Materials{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Dresses & Gowns{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Dresses{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Dupatas{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Jeans & Jeggings{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Kurtas{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Night & Lounge sets{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Pants{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Sarees{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Suit Sets{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Track Pants{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-2 mb-2 p-0">
            <div className="accordion " id="accordionGirls">
              <div className="accordion-item mb-0">
                <h6 className="accordion-header" id="headingGirls">
                  <button
                    className="accordion-button p-0 align-items-baseline font-weight-bold text-xl"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseGirls"
                    aria-expanded="false"
                    aria-controls="collapseGirls"
                  >
                    <h6 className="text-dark text-normal">Girls</h6>
                    <small className="collapse-close  text-sm pt-1 position-absolute end-0 me-3">
                      <img src="../../assets/img/svg/down.svg" alt="" />
                    </small>
                    <small className="collapse-open text-sm pt-1 position-absolute end-0 me-3">
                      <img src="../../assets/img/svg/up.svg" alt="" />
                    </small>
                  </button>
                </h6>
                <div
                  id="collapseGirls"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingGirls"
                  data-bs-parent="#accordionGirls"
                >
                  <div className="accordion-body text-start text-sm">
                    <div className="input-group input-group-outline mb-3">
                      <input
                        type="text"
                        className="form-control w-100"
                        placeholder="Search for categories"
                      />
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Casual Shoes{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Chudidhar & Leggings{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Dresses & Frocks{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>

                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Dress Materials{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Ethinic Wear Sets{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Jackets & Shrugs{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Jumpsuits & Playsuits{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Jeans & Jeggings{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Kurtas & Kurtis{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Night & Lounge sets{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Pants{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Sarees{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Skirts{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Western Wear Sets{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-3 mb-2 p-0">
            <div className="accordion " id="accordionMen">
              <div className="accordion-item mb-0">
                <h6 className="accordion-header" id="headingMen">
                  <button
                    className="accordion-button p-0 align-items-baseline font-weight-bold text-xl"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseMen"
                    aria-expanded="false"
                    aria-controls="collapseMen"
                  >
                    <h6 className="text-dark text-normal">Men</h6>
                    <small className="collapse-close  text-sm pt-1 position-absolute end-0 me-3">
                      <img src="../../assets/img/svg/down.svg" alt="" />
                    </small>
                    <small className="collapse-open text-sm pt-1 position-absolute end-0 me-3">
                      <img src="../../assets/img/svg/up.svg" alt="" />
                    </small>
                  </button>
                </h6>
                <div
                  id="collapseMen"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingMen"
                  data-bs-parent="#accordionMen"
                >
                  <div className="accordion-body text-start text-sm">
                    <div className="input-group input-group-outline mb-3">
                      <input
                        type="text"
                        className="form-control w-100"
                        placeholder="Search for categories"
                      />
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Casual Shirts{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Jackets & Coats{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Jeans{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Kurtas & Shirts{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Suit Sets{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Suitings & Shirtings{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Track Pants{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Tracksuits{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Travel Bags{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Trouser & Pants{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Tshirts{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Wallets{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Watches{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Accessories{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-4 mb-2 p-0">
            <div className="accordion " id="accordionBoys">
              <div className="accordion-item mb-0">
                <h6 className="accordion-header" id="headingBoys">
                  <button
                    className="accordion-button p-0 align-items-baseline font-weight-bold text-xl"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseBoys"
                    aria-expanded="false"
                    aria-controls="collapseBoys"
                  >
                    <h6 className="text-dark text-normal">Boys</h6>
                    <small className="collapse-close  text-sm pt-1 position-absolute end-0 me-3">
                      <img src="../../assets/img/svg/down.svg" alt="" />
                    </small>
                    <small className="collapse-open text-sm pt-1 position-absolute end-0 me-3">
                      <img src="../../assets/img/svg/up.svg" alt="" />
                    </small>
                  </button>
                </h6>
                <div
                  id="collapseBoys"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingBoys"
                  data-bs-parent="#accordionBoys"
                >
                  <div className="accordion-body text-start text-sm">
                    <div className="input-group input-group-outline mb-3">
                      <input
                        type="text"
                        className="form-control w-100"
                        placeholder="Search for categories"
                      />
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          2 Piece Kurta sets{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Backpacks{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Bag Accessories{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Bags & Wallets{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Clothing Accessories{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Ethinic Sets{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Fashion Accessories{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Innerwear Sets{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Kurtas{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Nightsuit sets{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Pyjamas{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Sandals{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Shorts{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="form-check p-0 mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="fcustomCheck1"
                        />
                        <label className="custom-control-label ms-3">
                          Sneakers{" "}
                          <small className="text-dark ms-1">(10,000)</small>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="tab-pane fade "
        id="v-pills-sort"
        role="tabpanel"
        aria-labelledby="v-pills-sort-tab"
      >
        <div>
          <div className="mb-3">
            <h5 className="text-normal text-black">Sort By</h5>
          </div>
          <div className="form-check p-0 mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              value=""
              id="fcustomCheck1"
            />
            <label className="custom-control-label ms-3">
              Price (Highest First)
            </label>
          </div>
        </div>
        <div>
          <div className="form-check p-0 mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              value=""
              id="fcustomCheck1"
            />
            <label className="custom-control-label ms-3">Discount</label>
          </div>
        </div>
        <div>
          <div className="form-check p-0 mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              value=""
              id="fcustomCheck1"
            />
            <label className="custom-control-label ms-3">
              Price (Lowest First)
            </label>
          </div>
        </div>
        <div>
          <div className="form-check p-0 mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              value=""
              id="fcustomCheck1"
            />
            <label className="custom-control-label ms-3">What's New</label>
          </div>
        </div>
        <div>
          <div className="form-check p-0 mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              value=""
              id="fcustomCheck1"
            />
            <label className="custom-control-label ms-3">Relevance</label>
          </div>
        </div>
        <div>
          <div className="form-check p-0 mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              value=""
              id="fcustomCheck1"
            />
            <label className="custom-control-label ms-3">New Arrivals</label>
          </div>
        </div>
      </div>
      <div
        className="tab-pane fade"
        id="v-pills-gender"
        role="tabpanel"
        aria-labelledby="v-pills-gender-tab"
      >
        <div>
          <div>
            <div className="mb-3">
              <h5 className="text-normal text-black">Gender</h5>
            </div>
            <div className="form-check mb-2">
              <input
                className="form-check-input"
                type="checkbox"
                value=""
                id="fcustomCheck1"
              />
              <label className="custom-control-label ms-3">
                Women <small className="text-dark ms-1">(10,000)</small>
              </label>
            </div>
          </div>
          <div>
            <div className="form-check mb-2 ">
              <input
                className="form-check-input"
                type="checkbox"
                value=""
                id="fcustomCheck1"
              />
              <label className="custom-control-label ms-3">
                Girls <small className="text-dark ms-1">(10,000)</small>
              </label>
            </div>
          </div>
          <div>
            <div className="form-check mb-2 ">
              <input
                className="form-check-input"
                type="checkbox"
                value=""
                id="fcustomCheck1"
              />
              <label className="custom-control-label ms-3">
                Infants <small className="text-dark ms-1">(10,000)</small>
              </label>
            </div>
          </div>
          <div>
            <div className="form-check mb-2 ">
              <input
                className="form-check-input"
                type="checkbox"
                value=""
                id="fcustomCheck1"
              />
              <label className="custom-control-label ms-3">
                Men <small className="text-dark ms-1">(10,000)</small>
              </label>
            </div>
          </div>
          <div>
            <div className="form-check mb-2 ">
              <input
                className="form-check-input"
                type="checkbox"
                value=""
                id="fcustomCheck1"
              />
              <label className="custom-control-label ms-3">
                Boys <small className="text-dark ms-1">(10,000)</small>
              </label>
            </div>
          </div>
          <div>
            <div className="form-check mb-2 ">
              <input
                className="form-check-input"
                type="checkbox"
                value=""
                id="fcustomCheck1"
              />
              <label className="custom-control-label ms-3">
                Kids <small className="text-dark ms-1">(10,000)</small>
              </label>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterDetails;
